interface SearchStatusProps {
  resultQuantity: number;
  resultsShown: boolean;
  isLoading?: boolean;
}

export const searchStatus = ({
  isLoading = false,
  resultQuantity,
  resultsShown,
}: SearchStatusProps): string => {
  if (isLoading) return bfTranslate('Search loading');
  if (resultsShown) {
    if (resultQuantity === 0) return bfTranslate('No results to display');
    if (resultQuantity === 1) return bfTranslate('1 result displayed');
    if (resultQuantity > 1) return `${resultQuantity} ${bfTranslate('results displayed')}`;
  }
  return bfTranslate('No search input'); // not loading and no search inputs
};
